module.exports = "/_next/static/images/20529608395e16ea39f29f60f21b9216-debit-phone.png.webp";